import React from 'react';
import { Box, Container, Flex, Heading, Text } from '@chakra-ui/react';
import MemberHeroSection from '@/components/membership/MemberHeroSection';

const masterLinkData = [
  {
    id: 'aifs-1',
    date: '07 May 2024',
    text: 'Master Circular for Alternative Investment Funds (AIFs)',
    link: 'https://static.levocdn.com/WGLBUT82/MasterCircularforAlternativeInvestmentFundsAIFs07052024-OaJcELBAThuJ1.pdf',
  },
];

const linksData = [
  {
    id: 'aifs-48',
    date: '06 June 2025',
    text: 'Extension of timeline of additional liquidation period for VCFs migrating to SEBI (Alternative Investment Funds) Regulations, 2012',
    link: 'https://static.levocdn.com/WGLBUT82/ExtensionoftimelineofadditionalliquidationperiodforVCFsmigratingtoSEBIAlternativeInvestmentFundsRegulations2012-rSCFmlHQHSh0W.pdf',
  },
  {
    id: 'aifs-123123',
    date: '13 May 2025',
    text: 'Extension of timeline for complying with the certification requirement for the key investment team of the Manager of AIF',
    link: 'https://static.levocdn.com/WGLBUT82/ExtensionoftimelineforcomplyingwiththecertificationrequirementforthekeyinvestmentteamoftheManagerofAIF300425-vxmowzQGUabg8.pdf',
  },
  {
    id: 'aifs-1',
    date: '30 April 2025',
    text: 'Clarifications to Cybersecurity and Cyber Resilience Framework (CSCRF) for SEBI Regulated Entities (REs)"',
    link: 'https://static.levocdn.com/WGLBUT82/ClarificationstoCybersecurityandCyberResilienceFrameworkCSCRFforSEBIRegulatedEntitiesREs30042025-Bwj5oGREp0nC.pdf',
  },

  {
    id: 'aifs-1',
    date: '28 March 2025',
    text: 'Extension towards Adoption and Implementation of Cybersecurity and Cyber Resilience Framework (CSCRF) for SEBI Regulated Entities (REs)',
    link: 'https://static.levocdn.com/WGLBUT82/ExtensiontowardsAdoptionandImplementationofCybersecurityandCyberResilienceFrameworkCSCRFforSEBIRegulatedEntitiesREs28032025-6Hgb7xPMycieq.pdf',
  },
  {
    id: 'aifs-1',
    date: '03 March 2025',
    text: 'Relaxation in timeline for reporting of differential rights issued by AIFs',
    link: 'https://static.levocdn.com/WGLBUT82/RelaxationintimelineforreportingofdifferentialrightsissuedbyAIFs03032025-5AQCcZx0T4kwO.pdf',
  },
  {
    id: 'aifs-2',
    date: '14 February 2025',
    text: "Relaxation in timelines for holding AIFs' investments in dematerialised form",
    link: 'https://static.levocdn.com/WGLBUT82/RelaxationintimelinesforholdingAIFsinvestmentsindematerialisedform14022025-JtagfEtW90uXP.pdf',
  },
  {
    id: 'aifs-3',
    date: '13 December 2024',
    text: 'Pro-rata and pari-passu rights of investors of AIFs',
    link: 'https://static.levocdn.com/WGLBUT82/Pro-rataandpari-passurightsofinvestorsofAIFs13122024-KQ5Y6QqoTdLKl.pdf',
  },
  {
    id: 'aifs-4',
    date: '08 October 2024',
    text: 'Specific due diligence of investors and investments of AIFs',
    link: 'https://static.levocdn.com/WGLBUT82/SpecificduediligenceofinvestorsandinvestmentsofAIFs08102024-jfwuBp7fWaQmV.pdf',
  },
  {
    id: 'aifs-5',
    date: '19 September 2024',
    text: 'Modification in framework for valuation of investment portfolio of AIFs',
    link: 'https://static.levocdn.com/WGLBUT82/ModificationinframeworkforvaluationofinvestmentportfolioofAIFs19092024-dO4QDwpc2NEqa.pdf',
  },
  {
    id: 'aifs-6',
    date: '19 August 2024',
    text: 'Guidelines for borrowing by Category I and Category II AIFs and maximum permissible limit for extension of tenure by VCFs',
    link: 'https://static.levocdn.com/WGLBUT82/GuidelinesforborrowingbyCategoryIandCategoryIIAIFsandmaximumpermissiblelimitforextensionoftenurebyLVFs19082024-ZnMdsUQ2R1uZ8.pdf',
  },
  {
    id: 'aifs-7',
    date: '09 July 2024',
    text: 'Information to be filed by schemes of AIFs availing dissolution period/additional liquidation period and conditions for in-specie distribution of assets of AIFs',
    link: 'https://static.levocdn.com/WGLBUT82/InformationtobefiledbyschemesofAIFsavailingdissolutionperiodadditionalliquidationperiodandconditionsforin-speciedistributionofassetsofAIFs09072024-VbXFgm3poda59.pdf',
  },
  {
    id: 'aifs-8',
    date: '13 May 2024',
    text: 'Certification requirement for key investment team or manager of AIF',
    link: 'https://static.levocdn.com/WGLBUT82/CertificationrequirementforkeyinvestmentteamofmanagerofAIF13052024-5AQCwZx0TX0tO.pdf',
  },
  {
    id: 'aifs-9',
    date: '26 April 2024',
    text: 'Framework for Category I and II Alternative Investment Funds (AIFs) to create encumbrance on their holding of equity of investee companies',
    link: 'https://static.levocdn.com/WGLBUT82/FrameworkforCategoryIandIIAlternativeInvestmentFundsAIFstocreateencumbranceontheirholdingofequityofinvesteecompanies26042024-VbXFUm3podZEp.pdf',
  },
  {
    id: 'aifs-10',
    date: '26 April 2024',
    text: 'Flexibility to Alternative Investment Funds (AIFs) and their investors to deal with unliquidated investments of their schemes',
    link: 'https://static.levocdn.com/WGLBUT82/FlexibilitytoAlternativeInvestmentFundsAIFsandtheirinvestorstodealwithunliquidatedinvestmentsoftheirschemes26042024-OaJNnLBATTive.pdf',
  },
  {
    id: 'aifs-11',
    date: '12 January 2024',
    text: 'Guidelines for AIFs with respect to holding their investments in dematerialised form and appointment of custodian',
    link: 'https://static.levocdn.com/WGLBUT82/GuidelinesforAIFswithrespecttoholdingtheirinvestmentsindematerialisedformandappointmentofcustodian12012024-74dG6DEv99cHM.pdf',
  },
  {
    id: 'aifs-12',
    date: '11 January 2024',
    text: 'Foreign investment in Alternative Investment Funds (AIFs)',
    link: 'https://static.levocdn.com/WGLBUT82/ForeigninvestmentinAlternativeInvestmentFundsAIFs11012024-30WTIpju66OW7.pdf',
  },
  {
    id: 'aifs-13',
    date: '11 December 2023',
    text: 'Credit of units of AIFs in dematerialised form',
    link: 'https://static.levocdn.com/WGLBUT82/CreditofunitsofAIFsindematerialisedform11122023-fF9iZWeOAAMxk.pdf',
  },
  {
    id: 'aifs-14',
    date: '14 September 2023',
    text: 'Regulatory Reporting by AIFs',
    link: 'https://static.levocdn.com/WGLBUT82/RegulatoryReportingbyAIFs14092023-KQ5YcQqoTTo9n.pdf',
  },
  {
    id: 'aifs-15',
    date: '04 August 2023',
    text: 'Validity period of approval granted by SEBI to Alternative Investment Funds (AIFs) and Venture Capital Funds (VCFs) for overseas investment',
    link: 'https://static.levocdn.com/WGLBUT82/ValidityperiodofapprovalgrantedbySEBItoAlternativeInvestmentFundsAIFsandVentureCapitalFundsVCFsforoverseasinvestment04082023-jfwuKp7fWWmUP.pdf',
  },
  {
    id: 'aifs-16',
    date: '21 June 2023',
    text: 'Standardised approach to valuation of investment portfolio of Alternative Investment Funds (AIFs)',
    link: 'https://static.levocdn.com/WGLBUT82/StandardisedapproachtovaluationofinvestmentportfolioofAlternativeInvestmentFundsAIFs21062023-bMZYbnDW7rG3I.pdf',
  },
  {
    id: 'aifs-17',
    date: '10 April 2023',
    text: 'Direct plan for schemes of Alternative Investment Funds (AIFs) and trail model for distribution commission in AIFs',
    link: 'https://static.levocdn.com/WGLBUT82/DirectplanforschemesofAlternativeInvestmentFundsAIFsandtrailmodelfordistributioncommissioninAIFs10042023-JtaznEtW9i70x.pdf',
  },
  {
    id: 'aifs-18',
    date: '12 January 2023',
    text: 'Participation of AIFs in Credit Default Swaps',
    link: 'https://static.levocdn.com/WGLBUT82/ParticipationofAIFsinCreditDefaultSwaps12012023-01TStMPLvkkm.pdf',
  },
  {
    id: 'aifs-19',
    date: '23 November 2022',
    text: 'Foreign investment in Alternative Investment Funds (AIFs)',
    link: 'https://static.levocdn.com/WGLBUT82/ForeigninvestmentinAlternativeInvestmentFundsAIFs09122022-FUGPXjWBqrIx.pdf',
  },
  {
    id: 'aifs-20',
    date: '17 November 2022',
    text: 'Circular - Schemes of AIF which have adopted priority in distribution among investors',
    link: 'https://static.levocdn.com/WGLBUT82/Circular-SchemesofAIFswhichhaveadoptedpriorityindistributionamonginvestors23122022-XZbabFD8EMtk.pdf',
  },
  {
    id: 'aifs-21',
    date: '01 February 2023',
    text: 'Transaction in Corporate Bonds through Request for Quote (RFQ) platform by Alternative Investment Funds (AIFs)',
    link: 'https://static.levocdn.com/WGLBUT82/TransactioninCorporateBondsthroughRequestforQuoteRFQplatformbyAlternativeInvestmentFundsAIFs01022023-JtaZEtW9s3hT.pdf',
  },
  {
    id: 'aifs-22',
    date: '17 November 2022',
    text: 'Guidelines for AIFs for declaration of first close, calculation of tenure and change of sponsor/manager or change in control of sponsor/manager',
    link: 'https://static.levocdn.com/WGLBUT82/GuidelinesforAIFsfordeclarationoffirstclosecalculationoftenureandchangeofsponsormanagerorchangeincontrolofsponsormanager17112022-PzNGMeI8pC5g.pdf',
  },
  {
    id: 'aifs-23',
    date: '17 August 2022',
    text: 'Guidelines for overseas investment by Alternative Investment Funds (AIFs) / Venture Capital Funds (VCFs)',
    link: 'https://static.levocdn.com/WGLBUT82/GuidelinesforoverseasinvestmentbyAlternativeInvestmentFundsAIFsVentureCapitalFundsVCFs17082022-pKkGluoBTzHU.pdf',
  },
  {
    id: 'aifs-24',
    date: '24 June 2022',
    text: 'Guidelines for Large Value Fund for Accredited Investors under SEBI (Alternative Investment Funds) Regulations, 2012 and Requirement of Compliance Officer for Managers of all AIFs',
    link: 'https://static.levocdn.com/WGLBUT82/GuidelinesforLargeValueFundforAccreditedInvestorsunderSEBIAlternativeInvestmentFundsRegulations2012andRequirementofComplianceOfficerforManagersofallAIFs24062022-uY2VYmsvzTQX.pdf',
  },
  {
    id: 'aifs-25',
    date: '28 March 2022',
    text: 'Circular on Calculation of investment concentration norm for Category III AIFs',
    link: 'https://static.levocdn.com/WGLBUT82/CircularonCalculationofinvestmentconcentrationnormforCategoryIIIAIFs28032022-VbX3km3popq5V.pdf',
  },
  {
    id: 'aifs-26',
    date: '27 January 2022',
    text: 'Introduction of Special Situation Funds as a sub-category under Category I AIFs',
    link: 'https://static.levocdn.com/WGLBUT82/IntroductionofSpecialSituationFundsasasub-categoryunderCategoryIAIFs27012022-uY2riYmsv3Lgg.pdf',
  },
  {
    id: 'aifs-27',
    date: '30 December 2021',
    text: 'Extension of timeline for modified reporting requirements for AIFs',
    link: 'https://static.levocdn.com/WGLBUT82/ExtensionoftimelineformodifiedreportingrequirementsforAIFs30122021-DNP1os0jhxf2j.pdf',
  },
  {
    id: 'aifs-28',
    date: '10 December 2021',
    text: 'Publishing Investor Charter and Disclosure of complaints by AIFs',
    link: 'https://static.levocdn.com/WGLBUT82/PublishingInvestorCharterandDisclosureofcomplaintsbyAIFs10122021-iPD7Qf0PTe03t.pdf',
  },
  {
    id: 'aifs-29',
    date: '31 May 2021',
    text: 'Circular on Relaxation in compliance with requirements pertaining to AIFs and VCFs',
    link: 'https://static.levocdn.com/WGLBUT82/CircularonRelaxationincompliancewithrequirementspertainingtoAIFsandVCFs31052021-eg6VLlkTjsfFL.pdf',
  },
  {
    id: 'aifs-30',
    date: '21 May 2021',
    text: 'Enhancement of overall limit for overseas investment by Alternative Investment Funds (AIFs)/Venture Capital Funds (VCFs)',
    link: 'https://static.levocdn.com/WGLBUT82/EnhancementofoveralllimitforoverseasinvestmentbyAlternativeInvestmentFundsAIFsVentureCapitalFundsVCFs21052021-aytSBN6WawKXu.pdf',
  },
  {
    id: 'aifs-31',
    date: '07 April 2021',
    text: 'Circular on Regulatory Reporting by AIFs',
    link: 'https://static.levocdn.com/WGLBUT82/CircularonRegulatoryReportingbyAIFs07042021-OaJczLBATKJWp.pdf',
  },
  {
    id: 'aifs-32',
    date: '08 January 2021',
    text: 'Circular on Amendment to Regulation 20(6) of SEBI (AIF) Regulations, 2012',
    link: 'https://static.levocdn.com/WGLBUT82/CircularonAmendmenttoRegulation206ofSEBIAIFRegulations201208012021-fF9zyWeOA6wIG.pdf',
  },
  {
    id: 'aifs-33',
    date: '22 October 2020',
    text: 'Processing of applications for registrations of AIFs and launch of schemes',
    link: 'https://static.levocdn.com/WGLBUT82/ProcessingofapplicationsforregistrationsofAIFsandlaunchofschemes22102020-iPD79f0PTrcOy.pdf',
  },
  {
    id: 'aifs-34',
    date: '30 June 2020',
    text: 'Collection of stamp duty on issue, transfer and sale of units of AIFs',
    link: 'https://static.levocdn.com/WGLBUT82/CollectionofstampdutyonissuetransferandsaleofunitsofAIFs30062020-UpL9iWyLqSvvD.pdf',
  },
  {
    id: 'aifs-35',
    date: '12 June 2020',
    text: "Clarifications with respect to Circular dated February 05, 2020 on 'Disclosure Standards for Alternative Investment Funds (AIFs)'",
    link: 'https://static.levocdn.com/WGLBUT82/ClarificationswithrespecttoCirculardatedFebruary052020onDisclosureStandardsforAlternativeInvestmentFundsAIFs12062020-ZnM7fUQ2RoKmV.pdf',
  },
  {
    id: 'aifs-36',
    date: '04 June 2020',
    text: 'Relaxation in compliance with requirements pertaining to AIFs and VCFs',
    link: 'https://static.levocdn.com/WGLBUT82/RelaxationincompliancewithrequirementspertainingtoAIFsandVCFs04062020-CISpyrOIh3gCe.pdf',
  },
  {
    id: 'aifs-37',
    date: '30 March 2020',
    text: 'Relaxation in compliance with requirements pertaining to AIFs and VCFs',
    link: 'https://static.levocdn.com/WGLBUT82/RelaxationincompliancewithrequirementspertainingtoAIFsandVCFs30032020-JtazDEtW9oesj.pdf',
  },
  {
    id: 'aifs-38',
    date: '30 March 2020',
    text: 'Extension of deadline for implementation of the circular on Stewardship Code for all Mutual Funds and all categories of AIFs due to the CoVID-19 pandemic',
    link: 'https://static.levocdn.com/WGLBUT82/ExtensionofdeadlineforimplementationofthecircularonStewardshipCodeforallMutualFundsandallcategoriesofAIFsduetotheCoVID-19pandemic30032020-rSCEhlHWJ4bTa.pdf',
  },
  {
    id: 'aifs-39',
    date: '05 February 2020',
    text: 'Disclosure Standards for Alternative Investment Funds (AIFs)',
    link: 'https://static.levocdn.com/WGLBUT82/DisclosureStandardsforAlternativeInvestmentFundsAIFs05022020-74dXnDEv9Doev.pdf',
  },
  {
    id: 'aifs-40',
    date: '24 December 2019',
    text: 'Stewardship Code for all Mutual Funds and all categories of AIFs, in relation to their investment in listed equities',
    link: 'https://static.levocdn.com/WGLBUT82/StewardshipCodeforallMutualFundsandallcategoriesofAIFsinrelationtotheirinvestmentinlistedequities24122019-gVHfGJ6Hit9Bb.pdf',
  },
  {
    id: 'aifs-41',
    date: '03 July 2018',
    text: 'Overseas Investment by Alternative Investment Funds (AIFs) / Venture Capital Funds (VCFs)',
    link: 'https://static.levocdn.com/WGLBUT82/OverseasInvestmentbyAlternativeInvestmentFundsAIFsVentureCapitalFundsVCFs03072018-EBh97xytOMtLQ.pdf',
  },
  {
    id: 'aifs-42',
    date: '29 September 2017',
    text: 'Change in reporting norms for Category III Alternative Investment Funds ("AIFs"), regarding investment in commodity derivatives market',
    link: 'https://static.levocdn.com/WGLBUT82/ChangeinreportingnormsforCategoryIIIAlternativeInvestmentFundsAIFsregardinginvestmentincommodityderivativesmarket29092017-YhEGgTNxSGHY7.pdf',
  },
  {
    id: 'aifs-43',
    date: '21 June 2017',
    text: 'Participation of Category III Alternative Investment Funds (AIFs) in the commodity derivatives market',
    link: 'https://static.levocdn.com/WGLBUT82/ParticipationofCategoryIIIAlternativeInvestmentFundsAIFsinthecommodityderivativesmarket21062017-EBh9QxytOVjIW.pdf',
  },
  {
    id: 'aifs-44',
    date: '15 March 2016',
    text: 'Investments by FPIs in REITs, InvITs, AIFs and corporate bonds under default',
    link: 'https://static.levocdn.com/WGLBUT82/InvestmentsbyFPIsinREITsInvItsAIFsandcorporatebondsunderdefault15032016-yCrP93MpPJyc7.pdf',
  },
  {
    id: 'aifs-45',
    date: '01 October 2015',
    text: 'Guidelines on overseas investments and other issues/clarifications for AIFs/VCFs',
    link: 'https://static.levocdn.com/WGLBUT82/GuidelinesonoverseasinvestmentsandotherissuesclarificationsforAIFsVCFs01102015-oilXsrVynwbJy.pdf',
  },
  {
    id: 'aifs-46',
    date: '18 July 2014',
    text: 'Clarification and extension of deadline with respect to circular on Guidelines on disclosure, reporting and clarifications under AIF Regulations',
    link: 'https://static.levocdn.com/WGLBUT82/ClarificationandextensionofdeadlinewithrespecttocircularonGuidelinesondisclosuresreportingandclarificationsunderAIFRegulations18072014-tryF1J0kpUa81.pdf',
  },
  {
    id: 'aifs-47',
    date: '19 June 2014',
    text: 'Guidelines on disclosure, reporting and clarifications under AIF Regulations',
    link: 'https://static.levocdn.com/WGLBUT82/GuidelinesondisclosuresreportingandclarificationsunderAIFRegulations19062014-GLUYRccOr0Zw1.pdf',
  },
];

const FundsRegulations = () => (
  <Flex direction="column" rowGap="20px">
    <MemberHeroSection
      title={
        <Heading
          as="h1"
          variant="headingText"
          color="text.headingWhite"
          fontSize={{ xs: '36px', sm: '60px' }}
          textAlign={{ xs: 'left', sm: 'left' }}
        >
          SEBI Alternative Investment Funds Regulations
        </Heading>
      }
      type="about-us"
    />
    <Container
      maxW="container.xl"
      pt={{ xs: '50px', md: '50px' }}
      pb={{ xs: '50px', md: '50px' }}
      as="section"
      id="info"
      scrollMarginTop="140px"
    >
      <Box>
        <Heading as="h2" fontSize="xl" mb={10} fontWeight="bold">
          Master Circular for Alternative Investment Funds
        </Heading>
        <Flex direction="column" gap="2">
          {masterLinkData.map((item) => (
            <Flex
              key={item.id}
              direction={{ base: 'column', md: 'row' }}
              cursor="pointer"
              gap={{ md: '5' }}
              onClick={() => {
                window.open(item?.link, '_blank');
              }}
            >
              <Flex minWidth="200px">
                {item?.date ? (
                  <Text
                    cursor="pointer"
                    //   variant="infoText"
                    variant="heroDesc"
                    color="text.mediumBlackAlpha"
                    _hover={{
                      textDecoration: 'underline',
                    }}
                  >
                    {item?.date}
                  </Text>
                ) : (
                  <Text
                    cursor="pointer"
                    //   variant="infoText"
                    variant="heroDesc"
                    color="text.mediumBlackAlpha"
                    _hover={{
                      textDecoration: 'underline',
                    }}
                  >
                    {item?.text}
                  </Text>
                )}
                {item.date && (
                  <Text
                    display={{ base: 'block', md: 'none' }}
                    cursor="pointer"
                    //   variant="infoText"
                    variant="heroDesc"
                    color="text.mediumBlackAlpha"
                    _hover={{
                      textDecoration: 'underline',
                    }}
                  >
                    :&nbsp;
                  </Text>
                )}
              </Flex>
              {item.date && (
                <Flex>
                  <Text
                    display={{ base: 'none', md: 'block' }}
                    cursor="pointer"
                    //   variant="infoText"
                    variant="heroDesc"
                    color="text.mediumBlackAlpha"
                    _hover={{
                      textDecoration: 'underline',
                    }}
                  >
                    :&nbsp;
                  </Text>
                  <Text
                    cursor="pointer"
                    //   variant="infoText"
                    variant="heroDesc"
                    color="text.mediumBlackAlpha"
                    _hover={{
                      textDecoration: 'underline',
                    }}
                  >
                    {item.text}
                  </Text>
                </Flex>
              )}
            </Flex>
          ))}
        </Flex>
      </Box>
      <Box mt={10}>
        <Heading as="h2" fontSize="xl" mb={10} fontWeight="bold">
          Regulatory Changes Introduced by SEBI in Alternative Investment Funds
        </Heading>
        <Flex direction="column" gap="2">
          {linksData?.map((item) => (
            <Flex
              key={item.id}
              direction={{ base: 'column', md: 'row' }}
              cursor="pointer"
              gap={{ md: '5' }}
              onClick={() => {
                window.open(item?.link, '_blank');
              }}
            >
              <Flex minWidth="200px">
                {item?.date ? (
                  <Text
                    cursor="pointer"
                    //   variant="infoText"
                    variant="heroDesc"
                    color="text.mediumBlackAlpha"
                    _hover={{
                      textDecoration: 'underline',
                    }}
                  >
                    {item?.date}
                  </Text>
                ) : (
                  <Text
                    cursor="pointer"
                    //   variant="infoText"
                    variant="heroDesc"
                    color="text.mediumBlackAlpha"
                    _hover={{
                      textDecoration: 'underline',
                    }}
                  >
                    {item?.text}
                  </Text>
                )}
                {item.date && (
                  <Text
                    display={{ base: 'block', md: 'none' }}
                    cursor="pointer"
                    //   variant="infoText"
                    variant="heroDesc"
                    color="text.mediumBlackAlpha"
                    _hover={{
                      textDecoration: 'underline',
                    }}
                  >
                    :&nbsp;
                  </Text>
                )}
              </Flex>
              {item.date && (
                <Flex>
                  <Text
                    display={{ base: 'none', md: 'block' }}
                    cursor="pointer"
                    //   variant="infoText"
                    variant="heroDesc"
                    color="text.mediumBlackAlpha"
                    _hover={{
                      textDecoration: 'underline',
                    }}
                  >
                    :&nbsp;
                  </Text>
                  <Text
                    cursor="pointer"
                    //   variant="infoText"
                    variant="heroDesc"
                    color="text.mediumBlackAlpha"
                    _hover={{
                      textDecoration: 'underline',
                    }}
                  >
                    {item.text}
                  </Text>
                </Flex>
              )}
            </Flex>
          ))}
        </Flex>
      </Box>
    </Container>
  </Flex>
);

export default FundsRegulations;
